import { Badge } from "@/components/ui/badge";
import { ScoresDetails } from "@/lib/api/mentor-scoring";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import { Button } from "../ui/button";
import { useRouter } from "@tanstack/react-router";


export const columns: ColumnDef<ScoresDetails>[] = [
  {
    accessorKey: "snapshot_date",
    header: "Date",
    cell: ({ row }) => {
      return (
        <div className="text-sm text-gray-500">
          {format(new Date(row.original.snapshot_date), "MMM d, yyyy")}
        </div>
      );
    },
  },
  {
    accessorKey: "final_score",
    header: "Final Score",
    cell: ({ row }) => {
      const score = row.original.final_score;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "average_score",
    header: "Average Satisfaction Score",
    cell: ({ row }) => {
      const score = row.original.average_satisfaction_score;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score ?? "N/A"}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "active_teens",
    header: "Total Active Teens",
    cell: ({ row }) => {
      const score = row.original.total_active_teens;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "last_window_teens",
    header: "Teens Last Window",
    cell: ({ row }) => {
      const score = row.original.total_mentees_last_window;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "first_week_engagement_count",
    header: "First week engaged teens",
    cell: ({ row }) => {
      const score = row.original.first_week_engagement_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month1_retention_count",
    header: "Month 1 teens retained",
    cell: ({ row }) => {
      const score = row.original.month1_retention_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month3_retention_count",
    header: "Month 3 teens retained",
    cell: ({ row }) => {
      const score = row.original.month3_retention_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "view_snapshot_details",
    header: "View Details",
    cell: ({ row }) => {
      const router = useRouter();
      return (
        <div className="text-sm text-black-500">
          <Button onClick={(event) => {
                    event.stopPropagation();
                    router.navigate({
                      to: `/mentor-scoring/details/${row.original.id}`,
                    });
                  }} variant="outline" className="mx-auto flex">
            View Details
          </Button>
        </div>
      );
    },
  },
];
